<template>
  <div class="company-menu">
    <div class="dropdown">
      <button class="dropbtn">
        <font-awesome-icon class="ellipsis-icon" icon="ellipsis-h"/>
      </button>
      <div class="dropdown-content">
        <a v-if="this.company.state.favorite === 0" v-on:click="setFavorite(1)"
        >Favoriet</a
        >
        <a v-else v-on:click="setFavorite(0)">Verwijderen van favorieten</a>
        <a v-if="this.company.state.exact === 0" v-on:click="setExact(1)"
        >Exact</a
        >
        <a v-else v-on:click="setExact(0)">Verwijderen van exact</a>
        <a v-if="this.company.state.urgent === 0" v-on:click="setUrgent(1)"
        >Urgent</a
        >
        <a v-else v-on:click="setUrgent(0)">Verwijderen van urgentie</a>
        <a v-on:click="notRelevant(this.company)">Verwijderen</a>
      </div>
    </div>
  </div>
</template>

<script>
import {central_api_domain} from "@/constants/endpoints";

export default {
  name: "CompanyMenu",
  props: {
    company: Object,
  },
  methods: {
    setFavorite(value) {
      this.company.state.favorite = value;
      this.updateCompanyState(this.company.state);
    },
    setExact(value) {
      this.company.state.exact = value;
      this.updateCompanyState(this.company.state);
    },
    setUrgent(value) {
      this.company.state.urgent = value;
      this.updateCompanyState(this.company.state);
    },
    updateCompanyState(state) {
      const url = central_api_domain + "states";
      let fetchData = {
        method: "PUT",
        body: JSON.stringify(state),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      fetch(url, fetchData)
          .then((res) => res.json())
    },
    notRelevant(company) {
      company.relevant = 0;
      const url = central_api_domain + "organisations";
      let fetchData = {
        method: "PUT",
        body: JSON.stringify(company),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      fetch(url, fetchData)
          .then((res) => res.json())
          .then(() => {
            history.back();
          });
    },
  },
};
</script>
